import { type SxProps, type Theme } from "@mui/material";

import { mergeSx } from "ui/merge-sx";

import { ACTIONS_SPACING } from "ui/dialog/dialog.constants";
import { type DialogActionsType } from "ui/dialog/dialog-actions/dialog-actions.types";

const DIALOG_ACTIONS_ROW_SX: SxProps<Theme> = { display: "flex", gap: `${ACTIONS_SPACING}px` };

export const DIALOG_ACTIONS_SX_BY_TYPE = {
  generic: mergeSx(DIALOG_ACTIONS_ROW_SX, { justifyContent: "flex-start" }),
  process: mergeSx(DIALOG_ACTIONS_ROW_SX, { justifyContent: "flex-end" }),
  steps: mergeSx(DIALOG_ACTIONS_ROW_SX, { justifyContent: "space-between", alignItems: "center" }),
} satisfies Record<DialogActionsType, SxProps<Theme>>;

export const DIALOG_ACTIONS_GROUP_SX: SxProps<Theme> = {
  display: "flex",
  gap: `${ACTIONS_SPACING}px`,
};
